import React, { useState } from "react";
import { floorPlans } from "../mock";
import { Lock, ArrowRight } from "lucide-react";

const FloorPlans = ({ onEnquire }) => {
  const [active, setActive] = useState(0);
  return (
    <section id="floor-plans-section" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${floorPlans.bg})`, backgroundSize: "cover" }}>
      <div className="absolute inset-0 bg-[#f4ede2]/90" />
      <img src={floorPlans.flower} alt="" className="ornament right-0 top-10 w-40 opacity-70" />
      <div className="relative max-w-[1220px] mx-auto px-5 lg:px-8">
        <div className="section-head">
          <p className="eyebrow">Floor Plans</p>
          <div className="divider-leaf my-3" />
          <h2 className="h-title">One Address That Has It All</h2>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {floorPlans.tabs.map((t, i) => (
            <button key={t.label} onClick={() => setActive(i)}
              className={`px-5 py-2.5 rounded-full font-display-e text-[11px] tracking-[.2em] transition-all border ${
                active === i ? "bg-[#2a3d5c] text-white border-[#2a3d5c]" : "bg-white/80 text-[#2a3d5c] border-[#c26a4a]/40 hover:bg-[#c26a4a]/10"
              }`}>
              {t.label.toUpperCase()}
            </button>
          ))}
        </div>

        <div className="relative rounded-[22px] overflow-hidden bg-white shadow-[0_24px_60px_rgba(31,58,42,0.18)] border border-[#c26a4a]/25">
          <img src={floorPlans.tabs[active].image} alt={floorPlans.tabs[active].label} className="w-full max-h-[620px] object-contain bg-[#f8f2e8] blur-[3px]" />
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-[#f8f2e8]/60 backdrop-blur-[2px]">
            <div className="bg-white/95 rounded-2xl p-8 text-center shadow-lg max-w-md mx-4">
              <Lock className="mx-auto text-[#c26a4a] mb-3" size={36} />
              <h4 className="h-title text-[22px]">Unlock {floorPlans.tabs[active].label}</h4>
              <p className="text-sm text-[#6b6a63] mt-2">Share your details to view the detailed floor plan.</p>
              <button onClick={onEnquire} className="btn-gold mt-5">GET FLOOR PLAN <ArrowRight size={14} /></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FloorPlans;
